import { render } from "./Colors.vue?vue&type=template&id=0084560e&scoped=true"
const script = {}

import "./Colors.vue?vue&type=style&index=0&id=0084560e&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0084560e"]])

export default __exports__